export enum StateType {
    SinValidar = 108,
    NombreYApellidoValidados = 109,
    NombreApellidoSexoFechaNacimientoValidados = 110
}